import { TRANSITION_LOTTIE_SPEEDY_SOUND_URL, TRANSITION_LOTTIE_TOING_SOUND_URL } from "../constants";
import { MARKER_NAMES, TRANSITION_LOTTIE_TRING_SOUND_URL } from "../constants";
import { getLottieSoundMarker } from "../helpers";
import { CartType } from "./constant";

export const getCartType = ({
    isAffordableCartM2,
    isBoltCartM3,
    isSwiggyBlackOtpAnimationApplicable,
    isToingFlow,
}: {
    isAffordableCartM2?: boolean;
    isBoltCartM3?: boolean;
    isSwiggyBlackOtpAnimationApplicable?: boolean;
    isToingFlow?: boolean;
}): CartType => {
    if (isAffordableCartM2) return CartType.AFFORDABLE_M2;
    if (isBoltCartM3 && !isSwiggyBlackOtpAnimationApplicable) return CartType.BOLT_M3;
    if (isToingFlow) return CartType.TOING;
    return CartType.DEFAULT;
};

export const getSoundMarkerConfig = ({
    isAffordableCartM2,
    isBoltCartM3,
    isSwiggyBlackOtpAnimationApplicable,
    lottieData,
    isToingFlow,
}: {
    isAffordableCartM2?: boolean;
    isBoltCartM3?: boolean;
    isSwiggyBlackOtpAnimationApplicable?: boolean;
    lottieData: any;
    isToingFlow?: boolean;
}) => {
    const cartType = getCartType({
        isAffordableCartM2,
        isBoltCartM3,
        isSwiggyBlackOtpAnimationApplicable,
        isToingFlow,
    });

    switch (cartType) {
        case CartType.AFFORDABLE_M2:
            return getLottieSoundMarker(lottieData, MARKER_NAMES.TRING_SOUND);
        case CartType.BOLT_M3:
            return getLottieSoundMarker(lottieData, MARKER_NAMES.SPEEDY_SOUND);
        case CartType.TOING:
            return getLottieSoundMarker(lottieData, MARKER_NAMES.TOING_SOUND);
        default:
            return getLottieSoundMarker(lottieData, MARKER_NAMES.TRING_SOUND);
    }
};

// Helper to select the correct sound url
export function getTransitionSoundUrl({
    isBoltCartM3,
    isSwiggyBlackOtpAnimationApplicable,
    isAffordableCartM2,
    isToingFlow,
}: {
    isBoltCartM3?: boolean;
    isSwiggyBlackOtpAnimationApplicable?: boolean;
    isAffordableCartM2?: boolean;
    isToingFlow?: boolean;
}) {
    if (isAffordableCartM2) {
        return TRANSITION_LOTTIE_TRING_SOUND_URL;
    }
    if (isBoltCartM3) {
        if (isSwiggyBlackOtpAnimationApplicable) {
            return TRANSITION_LOTTIE_TRING_SOUND_URL;
        }
        return TRANSITION_LOTTIE_SPEEDY_SOUND_URL;
    }
    if (isToingFlow) {
        return TRANSITION_LOTTIE_TOING_SOUND_URL;
    }
    return TRANSITION_LOTTIE_TRING_SOUND_URL;
}
